module.exports = __webpack_public_path__ + "img/close.7ad8bc1a.svg";